import * as _ from 'lodash';
import * as featuresApi from '../../api/features.service';
import * as usersApi from '../../api/users.service';
import {
  ApplicationRoutesNgService,
  Route,
} from '../routeGuard/applicationRoutesNg.service';

export const HomeNavComponent = {
  bindings: {
    isBuyer: '<',
    isSeller: '<',
    isGpo: '<',
    isHistory: '<',
    shelf: '<',
    createRequestUrl: '<',
    isPartner: '<',
    featureList: '<',
    downloadUrl: '=',
  },
  controller: class {
    featureList: featuresApi.FeatureFlags;
    applicationPermissions: usersApi.ApplicationPermission[];
    account: any;
    partnersLink: boolean;
    canCreatePricingRequest: boolean;
    createRequestUrl;
    isBuyer: boolean = false;
    isSeller: boolean = false;
    Route = Route;

    constructor(
      private $window,
      private $location,
      private api,
      private $route,
      private applicationRoutesNgService: ApplicationRoutesNgService,
    ) {
      'ngInject';
    }

    get currentRouteName() {
      return this.$route.current.name;
    }

    getOfferSellerRouterLink() {
      if (this.featureList.OFFER_NEW_SIO_PAGE_PROD_OUTAGE) {
        return Route.RECOMMENDED_SELLER_INITAITED_OFFER;
      }
      return '/aptitude/static/home.html#/list/SELLER_OFFER';
    }

    getRespondRouterLink() {
      return Route.RESPOND_SELLER;
    }

    createRequest() {
      this.$window.location = this.createRequestUrl;
    }

    // FIXME: make API requests at the parent level
    $onInit() {
      this.api.users.currentUser().then(({ userId, isBuyer, isSeller }) => {
        this.api.features.getFeatures().then((featureList) => {
          this.featureList = featureList;

          if (this.$location.path() === '/cards') {
            this.$window.location.href = this.applicationRoutesNgService.get(
              Route.HOME_LANDING,
            );
          }
        });

        this.api.users
          .applicationPermissions(userId, 'APTITUDE', null, null, true)
          .then((permissions) => {
            this.partnersLink = _.some(permissions, {
              action: 'PARTNERS_LINK',
              allowed: true,
            });
            this.canCreatePricingRequest = _.some(permissions, {
              action: 'CREATE_PRICING_REQUEST',
              allowed: true,
            });
          });
      });
    }
  },

  template: `<aptitude-nav ng-if="$ctrl.isBuyer || $ctrl.isGpo">
               <gutter/>
               <nav-item data-test-selector="create-shelf" url="'/aptitude/static/platform/home/list/BUYER_REQUEST'"
                         active="$ctrl.shelf === 'BUYER_REQUEST' && !$ctrl.isHistory">
                 Create
               </nav-item>
               <!-- Notice path is passed on to filter navPathWithToggleValue-->
               <nav-item data-test-selector="execute-shelf" url="'/aptitude/static/home.html#/execute/view/list/filter/activeOpportunities'"
                         active="$ctrl.currentRouteName === 'execute'">
                 Execute
               </nav-item>

               <nav-item data-test-selector="manage-shelf"
                         url="'/aptitude/static/platform/home/manageList'"
                         active="$ctrl.currentRouteName === 'manage'">
                 Manage
               </nav-item>

               <nav-item data-test-selector="catalog"
                         url="'/aptitude/static/platform/home/categories'"
                         active="$ctrl.currentRouteName === 'catalog'">
                 Catalog
               </nav-item>

               <nav-item data-test-selector="participation-shelf" ng-if="$ctrl.partnersLink && !$ctrl.featureList.MEMBER_RECRUITING_REPORT_ENHANCEMENTS_PPI_3333"
                         url="'/aptitude/static/home.html#/participation/'"
                         active="$ctrl.currentRouteName === 'participation'">
                 Participation
               </nav-item>
                <nav-item data-test-selector="partners-shelf" ng-if="$ctrl.partnersLink && $ctrl.featureList.MEMBER_RECRUITING_REPORT_ENHANCEMENTS_PPI_3333"
                        url="'/aptitude/static/platform/home/partners'"
                         active="$ctrl.currentRouteName === 'partners'">
                 Participation
               </nav-item>
               <gap/>
               <nav-download
                 url="$ctrl.downloadUrl"
                 ng-if="$ctrl.downloadUrl">
               </nav-download>

               <nav-button click="$ctrl.createRequest()" disabled="!$ctrl.canCreatePricingRequest">Create Request</nav-button>
               <gutter/>
             </aptitude-nav>

             <!--Seller navigation-->
             <aptitude-nav ng-if="$ctrl.isSeller">
               <gutter/>
               <nav-item test-data-selector="seller-offer-shelf" url="$ctrl.getOfferSellerRouterLink()"
                         active="$ctrl.shelf === 'SELLER_OFFER' && !$ctrl.isHistory">
                 Offer
               </nav-item>
               <nav-item test-data-selector="seller-respond-shelf" url="$ctrl.getRespondRouterLink()"
                         active="$ctrl.shelf === 'SELLER_RESPOND' && !$ctrl.isHistory">
                 Respond
               </nav-item>
               <nav-item test-data-selector="seller-execute-shelf" url="'/aptitude/static/home.html#/list/SELLER_ACCEPT'"
                         active="$ctrl.shelf === 'SELLER_ACCEPT' && !$ctrl.isHistory">
                 Execute
               </nav-item>
               <nav-item test-data-selector="seller-manage-shelf"
                        url="'/aptitude/static/platform/home/manageList'"
                        active="($ctrl.shelf === 'SELLER_MEASURE' && !$ctrl.isHistory) || $ctrl.currentRouteName === 'manage'">
                 Manage
               </nav-item>

               <nav-item test-data-selector="seller-catalog-shelf"
                         url="'/aptitude/static/platform/home/categories'"
                         active="$ctrl.currentRouteName === 'catalog'">
                 Catalog
               </nav-item>
               <gutter/>
             </aptitude-nav>`,
};
